export default function validatePassword(rule, value, callback) {
  if (value === '') {
    callback(new Error('请输入密码'))
  } else if (!/^[\w!@#$%^&*\-_]{6,16}$/.test(value)) {
    callback(new Error('密码应为6到16位的数字字母和!@#$%^&*-_组成'))
  } else {
    callback()
  }
}
